const content: { [key: string]: string } = {
  headline: "We're working on it",
  content: "Why don't you check back with us in a bit.",
};

export default content;
